<template>
  <div class="container">
    <ul class="settings-container">
      <li v-for="(value, key) in settings" :key="key" class="setting-box">
        <p v-if="key === 'vouchers'" class="last-item">{{ formatSettingName(key) }}</p>
        <p v-else >{{ formatSettingName(key) }}</p>
        <ToggleSwitch :modelValue="value" :modelName="key" @update:modelValue="saveSetting(key, $event)" />
        <label v-if="key === 'vouchers'" for="voucherExpiry">Voucher Expiry:</label>
        <select v-if="key === 'vouchers'" class="voucherExpiry" v-model="voucherExpiry" @change="saveVoucherExpiry">
          <option value="0" selected>No Expiry</option>
          <option value="6">6 Months</option>
          <option value="12">1 Year</option>
          <option value="24">2 Years</option>
          <option value="36">3 Years</option>
        </select>
      </li>
    </ul>
  </div>
</template>

<script>
import { ToggleSwitch } from "@monolith/components";
import { mapGetters } from "vuex";

export default {
  name: "DirectSettings",
  components: {
    ToggleSwitch,
  },
  data() {
    return {
      settings: {},
      voucherExpiry: 0,
    };
  },

  emits: ["updateSettings"],

  props: {
    site: {
      type: String,
      required: true,
    },
  },

  mounted() {
    this.$store.dispatch("getSettings");
    this.filterSettings();
    let currSite = this.site;
    this.voucherExpiry = "voucher_expiry" in this.siteSettings[currSite] ? this.siteSettings[currSite].voucher_expiry : 0;
  },

  computed: {
    ...mapGetters({
      settingsViaSite: "settingsViaSite",
      channels: "channels",
      siteSettings: "siteSettings",
    }),
  },

  methods: {
    filterSettings() {
      let setting = {};
      let s = this.settingsViaSite(this.site).filter((setting) => typeof setting[1] === "boolean");
      s.map((i) => (setting[i[0]] = i[1]));
      this.settings = setting;
      return Object.entries(setting);
    },

    formatSettingName(setting) {
      if (typeof setting == "string" && setting.includes("_")) {
        setting = setting.replace(/_/g, " ");
      } else if (typeof setting == "string" && setting.match(/([A-Z])/g)) {
        setting = setting.replace(/([A-Z])/g, " $1");
      }
      return setting;
    },

    saveVoucherExpiry() {
      let topic = this.channel.topic.split(":");
      if (topic[0] == "pos" && topic[2] == this.site) {
        this.channel.push("company:site:setting", { key: "voucher_expiry", value: this.voucherExpiry }).receive("ok", () => {
          this.filterSettings();
          this.$store.dispatch("setKeyValue", "voucher_expiry", this.voucherExpiry, this.site);
        });
      }
    },
    
    saveSetting(s, value) {
      let topic = this.channel.topic.split(":");
      if (topic[0] == "bridge") {
        this.channel.push("company:site:setting", { site: this.site, key: s, value: value }).receive("ok", () => {
          this.filterSettings();
          this.$store.dispatch("setKeyValue", s, value, this.site);
          if (s == "openClose") {
            this.channel.push("company:site:close", { status: value });
          }
        });
      }
    },
  },
  watch: {
    siteSettings: {
      handler() {
        this.filterSettings();
      },
      deep: true
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 97.5%;
  /* padding: 0 1rem; */
}

.voucherExpiry {
  background-color: var(--secondary-colour);
  color: var(--text-colour);
  border: 1px solid var(--action-colour);
  border-radius: 0.5rem;
  padding: 0.25rem;
  margin: 0.25rem;
}
li:has(.last-item) {
  order: 999;
}

.settings-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  list-style: none;
  padding: 1rem;
  margin: 0;
  background: var(--primary-colour);
  border-radius: 20px;
}

.setting-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 10rem;
  padding: 0.5rem 0.5rem;
  border: none;
  box-shadow: var(--box-shadow);
  border-radius: 10px;
  margin: 0.5rem;
  background-color: var(--tertiary-colour);
  p {
    text-wrap: nowrap;
    margin: 0.5rem 0 0 0;
    text-transform: capitalize;
  }
}
@media only screen and (orientation: portrait) {
  .container {
    padding: 0;
    width: 95%;
  }
  .settings-container {
    display: grid;
    grid-template-columns: repeat(2, 0fr);
    gap: 0.25rem;
    align-items: center;
    justify-content: center;
    margin: 0.25rem;
    max-width: 90% !important;
  }
  .setting-box {
    /* height: 5rem; */
    margin: 0.25rem;
    padding: 0.25rem 0;
    height: 90%;
    min-width: 3rem;
  }
}
</style>
